import { TypedAction } from '@ngrx/store/src/models';
import { AppStateFailureBuilder, AppStateFailureItemWithErrorCode, FailureType } from '@symphony-solo/shared/common-state/src';
import { ApiResponseCode, LoyaltyResponse } from '@symphony-solo/shared/http/src';
import { authenticateErrorAction, AuthenticationActionTypes } from '../+state';
import { TokenResult } from '../models';
import { BaseHandler } from './base.handler';

export class UnknownErrorHandler extends BaseHandler {
  public handle(response: LoyaltyResponse<TokenResult>): TypedAction<AuthenticationActionTypes> {
    const failure = new AppStateFailureBuilder()
      .setFailureType(FailureType.Validation)
      .addFailure(new AppStateFailureItemWithErrorCode('Please try again later.', ApiResponseCode.Unknown_Error))
      .build();
    return authenticateErrorAction({ failure });
  }
}
